export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11703.52b3aada.jpg";